import { useEffect, useState } from 'react';

import { LinearProgress } from '@mui/material';
import { RouteComponentProps, useParams, useLocation } from 'react-router-dom';

// import { useCandidateContext } from 'hooks/useCandidateContext';
import { fetchOrganizationById } from 'api';
import { useSnackContext } from 'hooks/useSnackContext';
import { OrganizationVerboseProps } from 'types';

import { OrganizationEditForm } from './OrganizationEditForm';
export interface Props
  extends RouteComponentProps<{
    org_id: string;
  }> {}

export const OrganizationEditPage = () => {
  const { setSnack } = useSnackContext();
  const { org_id } = useParams<{ org_id: string }>();
  const [organization, setOrganization] =
    useState<OrganizationVerboseProps | null>(null);
  const location = useLocation();

  useEffect(() => {
    async function fetchOrganization() {
      const { data } = await fetchOrganizationById(parseInt(org_id, 10));
      setOrganization(data);
    }

    fetchOrganization().catch((e) =>
      setSnack((props) => ({
        ...props,
        severity: 'error',
        open: true,
        message: `Failed to Fetch Organization ${org_id}`,
        error: e as Error,
      })),
    );

    return () => {
      setOrganization(null);
    };
  }, [org_id, setOrganization, location.state, setSnack]);
  if (!organization) {
    return <LinearProgress sx={{ width: '100%' }} />;
  }

  return (
    <OrganizationEditForm
      organization={organization}
      setOrganization={
        setOrganization as React.Dispatch<
          React.SetStateAction<OrganizationVerboseProps>
        >
      }
    />
  );
};
